/**
 * Action types for user login functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGIN_FAIL_TOKEN = 'USER_LOGIN_FAIL_TOKEN';
export const USER_LOGIN_FAIL_ACCOUNT = 'USER_LOGIN_FAIL_ACCOUNT';
export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';

export const EMAIL_VERIFY_REQUEST = 'EMAIL_VERIFY_REQUEST';
export const EMAIL_VERIFY_SUCCESS = 'EMAIL_VERIFY_SUCCESS';
export const EMAIL_VERIFY_FAIL = 'EMAIL_VERIFY_FAIL';
export const EMAIL_VERIFY_RESET = 'EMAIL_VERIFY_RESET';

export const OTP_VERIFY_REQUEST = 'OTP_VERIFY_REQUEST';
export const OTP_VERIFY_SUCCESS = 'OTP_VERIFY_SUCCESS';
export const OTP_VERIFY_FAIL = 'OTP_VERIFY_FAIL';
export const OTP_VERIFY_RESET = 'OTP_VERIFY_RESET';

//   tenant 
export const USER_SIGNUP_REQUEST = 'USER_SIGNUP_REQUEST';
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_SIGNUP_FAIL = 'USER_SIGNUP_FAIL';
export const SIGNUP_VERIFY_FAIL = 'SIGNUP_VERIFY_FAIL';
export const SIGNUP_VERIFY_SUCCESS = 'SIGNUP_VERIFY_SUCCESS';
export const SIGNUP_VERIFY_REQUEST = 'SIGNUP_VERIFY_REQUEST';
export const SIGNUP_RESET = 'SIGNUP_RESET';

export const ZTP_DETAILS_GET = 'ZTP_DETAILS_GET';
export const ZTP_DETAILS_SUCCESS = 'ZTP_DETAILS_SUCCESS';
export const ZTP_DETAILS_GET_FAIL = 'ZTP_DETAILS_GET_FAIL';

export const REGION_DETAILS_GET = 'REGION_DETAILS_GET';
export const REGION_DETAILS_SUCCESS = 'REGION_DETAILS_SUCCESS';
export const REGION_DETAILS_GET_FAIL = 'REGION_DETAILS_GET_FAIL';

export const TENANT_REQUEST_GET = 'TENANT_REQUEST_GET';
export const TENANT_RESPONSE_GET_SUCCESS = 'TENANT_RESPONSE_GET_SUCCESS';
export const TENANT_RESPONSE_GET_FAIL = 'TENANT_RESPONSE_GET_FAIL';

export const RESET_TENANT_DELETE = 'RESET_TENANT_DELETE';
export const TENANT_DELETION_ERROR = 'TENANT_DELETION_ERROR';
export const TENANTS_DELETED_SUCCESSFULLY = 'TENANTS_DELETED_SUCCESSFULLY';

export const TENANT_RESPONSE_PUT_FAIL = 'TENANT_RESPONSE_PUT_FAIL';
export const DELETE_TENANT_RESPONSE_SUCCESS = 'DELETE_TENANT_RESPONSE_SUCCESS';
export const TENANT_REQUEST_PUT = 'TENANT_REQUEST_PUT';

export const TENANT_REQUEST_ADD = 'TENANT_REQUEST_ADD';
export const TENANT_RESPONSE_ADD_FAIL = 'TENANT_RESPONSE_ADD_FAIL';
export const TENANT_RESPONSE_ADD_SUCCESS = 'TENANT_RESPONSE_ADD_SUCCESS';
export const RESET_TENANT_ADD = 'RESET_TENANT_ADD';
export const TENANT_ADDED_SUCCESFULLY = 'TENANT_ADDED_SUCCESFULLY';
export const TENANT_ADD_ERROR = [
	'INTERNAL_SERVER_ERROR',
	'ADMIN_EMAIL_ALREADY_EXISTS',
	'A user with that username already exists.',
];

export const TENANT_DOWNLOAD_REQUEST = 'TENANT_DOWNLOAD_REQUEST';
export const TENANT_CREATION_INITIATED = 'TENANT_CREATION_INITIATED';
export const TENANT_DOWNLOAD_RESPONSE_ADD_SUCCESS = 'TENANT_DOWNLOAD_RESPONSE_ADD_SUCCESS';
export const TENANT_DOWNLAOD_RESPONSE_ADD_FAIL = 'TENANT_DOWNLAOD_RESPONSE_ADD_FAIL';
export const TENANT_DOWNLAOD_ADD_SUCCESS_MESSAGE = 'Tenant downloaded successfully';

export const TENANT_REQUEST_EDIT = 'TENANT_REQUEST_EDIT';
export const TENANT_RESPONSE_EDIT_FAIL = 'TENANT_RESPONSE_EDIT_FAIL';
export const TENANT_RESPONSE_EDIT_SUCCESS = 'TENANT_RESPONSE_EDIT_SUCCESS';
export const RESET_TENANT_EDIT = 'TENANT_EDITED_SUCCESFULLY';
export const TENANT_EDITED_SUCCESFULLY = 'TENANT_EDITED_SUCCESFULLY';
export const TENANT_EDIT_ERROR = [
	'INTERNAL_SERVER_ERROR',
	'ADMIN_EMAIL_ALREADY_EXISTS',
	'A user with that username already exists.',
];
export const TENANT_UPDATED_SUCCESSFULLY = 'TENANT_UPDATED_SUCCESSFULLY';

export const HOST_REQUEST_GET = 'HOST_REQUEST_GET';
export const HOST_RESPONSE_GET_SUCCESS = 'HOST_RESPONSE_GET_SUCCESS';
export const HOST_RESPONSE_GET_FAIL = 'HOST_RESPONSE_GET_FAIL';

export const NOTIFICATION_TENANT = 'NOTIFICATION_TENANT';
export const NOTIFICATION_TENANT_FAIL = 'NOTIFICATION_TENANT_FAIL';
export const NOTIFICATION_TENANT_SUCCESS = 'NOTIFICATION_TENANT_SUCCESS';
export const NOTIFICATION_TENANT_SUCCESS_MSG = 'PUSHED_NOTIFICATION_SUCCESSFULLY';
export const RESET_NOTIFICATION_TENANT_STATE = 'RESET_NOTIFICATION_TENANT_STATE';
export const SIGNUP_DATA = 'SIGNUP_DATA';


// Get user constants
export const GET_USERS = 'GET_USERS';
export const USER_REQUEST_GET = 'USER_REQUEST_GET';
export const USER_RESPONSE_GET_SUCCESS = 'USER_RESPONSE_GET_SUCCESS';
export const USER_RESPONSE_GET_FAIL = 'USER_RESPONSE_GET_FAIL';

export const DOWNLOAD_USER_LOGS = 'DOWNLOAD_USER_LOGS';
export const DOWNLOAD_USER_LOGS_SUCCESS = 'DOWNLOAD_USER_LOGS_SUCCESS';
export const DOWNLOAD_USER_LOGS_FAIL = 'DOWNLOAD_USER_LOGS_FAIL';

/**
 * Action types for put user data.
 *
 * These constants represent different stages of the user data deleting process
 */
export const USER_REQUEST_PUT = 'USER_REQUEST_PUT';
export const USER_RESPONSE_PUT_FAIL = 'USER_RESPONSE_PUT_FAIL';
export const DELETE_USER_RESPONSE_SUCCESS = 'DELETE_USER_RESPONSE_SUCCESS';
export const RESET_USER_DELETE = 'RESET_USER_DELETE';
export const USER_DELETED_SUCCESFULLY = 'USER_DELETED_SUCCESFULLY';
export const USER_DELETION_ERROR = 'USER_CANNOT_BE_DELETED';

export const USER_SELECTED = 'USER_SELECTED';

/** Action types for suspend user */

export const USER_REQUEST_SUSPEND = 'USER_REQUEST_SUSPEND';
export const USER_RESPONSE_SUSPEND_FAIL = 'USER_RESPONSE_SUSPEND_FAIL';
export const SUSPEND_USER_RESPONSE_SUCCESS = 'SUSPEND_USER_RESPONSE_SUCCESS';
export const RESET_USER_SUSPEND = 'RESET_USER_SUSPEND';
export const USER_SUSPENDED_SUCCESFULLY = 'ADMIN_KICKED_SUCCESSFULLY';
export const USER_SUSPEND_ERROR = 'USER_SUSPEND_ERROR';

/** Action types to add user */

export const USER_REQUEST_ADD = 'USER_REQUEST_ADD';
export const USER_RESPONSE_ADD_FAIL = 'USER_RESPONSE_ADD_FAIL';
export const USER_RESPONSE_ADD_SUCCESS = 'USER_RESPONSE__ADD_SUCCESS';
export const RESET_USER_ADD = 'RESET_USER_ADD';
export const USER_ADDED_SUCCESFULLY = 'ADMIN_KICKED_SUCCESSFULLY';
export const USER_ADD_ERROR = [
	'INTERNAL_SERVER_ERROR',
	'ADMIN_EMAIL_ALREADY_EXISTS',
	'A user with that username already exists.',
];
export const USER_ADD_ERROR_TYPES = ['username', 'non_field_errors'];
export const ERROR_MESSAGES = {
	username: 'A user with that username already exists.',
	non_field_errors: 'ADMIN_EMAIL_ALREADY_EXISTS',
	// Add other error mappings as needed
};

/** Action types to edit user */

export const USER_REQUEST_EDIT = 'USER_REQUEST_EDIT';
export const USER_RESPONSE_EDIT_FAIL = 'USER_RESPONSE_EDIT_FAIL';
export const USER_RESPONSE_EDIT_SUCCESS = 'USER_RESPONSE_EDIT_SUCCESS';
export const RESET_USER_EDIT = 'RESET_USER_EDIT';
export const USER_EDITED_SUCCESFULLY = 'USER_PROFILE_UPDATED_SUCCESSFULLY';
export const USER_EDIT_ERROR = [
	'INTERNAL_SERVER_ERROR',
	'ADMIN_EMAIL_ALREADY_EXISTS',
	'A user with that username already exists.',
];

export const ADMIN_DETAILS_GET = 'ADMIN_DETAILS_GET';
export const ADMIN_DETAILS_GET_FAIL = 'ADMIN_DETAILS_GET_FAIL';
export const ADMIN_DETAILS_SUCCESS = 'ADMIN_DETAILS_SUCCESS';

export const USER_EDIT_ERROR_TYPES = ['username', 'non_field_errors'];
export const EDIT_MESSAGES = {
	username: 'A user with that username already exists.',
	non_field_errors: 'ADMIN_EMAIL_ALREADY_EXISTS',
	// Add other error mappings as needed
};

export const UPDATE_ADMIN_PASSWORD = 'UPDATE_ADMIN_PASSWORD';
export const UPDATE_ADMIN_PASSWORD_SUCCESS = 'UPDATE_ADMIN_PASSWORD_SUCCESS';
export const UPDATE_ADMIN_PASSWORD_FAIL = 'UPDATE_ADMIN_PASSWORD_FAIL';

export const OTP_VERIFICATION = 'OTP_VERIFICATION';
export const OTP_VERIFICATION_SUCCESS = 'OTP_VERIFICATION_SUCCESS';
export const OTP_VERIFICATION_FAIL = 'OTP_VERIFICATION_FAIL';
export const RESET_VERIFICION_MSG = 'RESET_VERIFICION_MSG';

export const USER_ADD_TRIGGER = 'USER_ADD_TRIGGER';

/**
 * Register user Action Types
*/
export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_FAIL = 'REGISTER_USER_FAIL';
export const REGISTER_USER_OTP_VERIFY_REQUEST = 'REGISTER_USER_OTP_VERIFY_REQUEST';
export const REGISTER_USER_OTP_VERIFY = 'REGISTER_USER_OTP_VERIFY';
export const REGISTER_USER_OTP_VERIFY_FAIL = 'REGISTER_USER_OTP_VERIFY_FAIL';


/**
 * Forgot password Action Types
*/
export const REQUEST_FORGOT_PASSWORD = 'REQUEST_FORGOT_PASSWORD';
export const SAVE_FORGOT_PASSWORD = 'SAVE_FORGOT_PASSWORD';
export const SAVE_FORGOT_PASSWORD_FAIL = 'SAVE_FORGOT_PASSWORD_FAIL';
export const REQUEST_SAVE_TEMP_TOKEN = 'REQUEST_SAVE_TEMP_TOKEN';
export const SAVE_TEMP_TOKEN = 'SAVE_TEMP_TOKEN';
export const SAVE_TEMP_TOKEN_FAIL = 'SAVE_TEMP_TOKEN_FAIL';
export const REQUEST_UPDATE_NEWPASSWORD = "REQUEST_UPDATE_NEWPASSWORD";
export const SAVE_UPDATE_NEWPASSWORD = "SAVE_UPDATE_NEWPASSWORD";
export const SAVE_UPDATE_NEWPASSWORD_FAIL = "SAVE_UPDATE_NEWPASSWORD_FAIL";
export const SHOW_ALERT_FORGOT_PASSWORD = "SHOW_ALERT_FORGOT_PASSWORD";
